export const TASK_TRACKER_SIDEBAR_COLLAPSED_STORAGE_KEY =
  'task-tracker-crm:sidebar-collapsed'
